import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { DESKTOP_WIDTH, TABLET_WIDTH, MOBILE_WIDTH, MOBILE_S_WIDTH } from '../globalUtils';
import HomeBG from '../../images/home-bg.jpg';
import HomeBGL from '../../images/home-bg-low.jpg';
import HomeBGTablet from '../../images/home-bg-tablet.jpg';
import HomeBGTabletL from '../../images/home-bg-tablet-low.jpg';
import HomeBGMobile from '../../images/home-bg-mobile.jpg';
import HomeBGMobileL from '../../images/home-bg-mobile-low.jpg';

export const HomeContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    align-items: center;
`;

export const TopContainer = styled.div`
    width: 100%;
    height: 579px;
    background-image: url(${HomeBG}), url(${HomeBGL});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    display: flex;
    justify-content: center;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        background-image: url(${HomeBGTablet}), url(${HomeBGTabletL});
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        background-image: url(${HomeBGMobile}), url(${HomeBGMobileL});
        height: 328px;
    }
`;

export const Area = styled.div`
    width: ${DESKTOP_WIDTH}px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: ${TABLET_WIDTH}px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: ${MOBILE_WIDTH}px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: ${MOBILE_S_WIDTH}px;
    }
`;

export const TopText = styled.div`
    color: #003a70;
    font-size: 44px;
    padding: 0 0 45px 500px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 43px;
        padding: 0 0 50px 130px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 20px;
        padding: 0 20px 23px;
        text-align: center;
        font-weight: 600;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 18px;
    }
`;

export const RedText = styled.div`
    color: #ff4438;
    font-weight: 600;
`;

export const CTAButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 67px;
    width: 322px;
    background-color: #003a70;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    border: 1px solid rgb(0, 58, 112);
    color: #f1efef;
    font-size: 24px;
    
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 36px;
        width: 215px;
        border-radius: 3.6px;
        box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.5);
        font-size: 16px;
        align-self: center;
    }
`;

export const FlexRow = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1 0 auto;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        flex-direction: column;
        align-items: center;
    }
`;

export const FlexColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        align-items: center;
    }
`;

export const FlexRowFull = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1 0 auto;
    width: 100%;
`;

export const Title = styled.div`
    position: relative;
    cursor: pointer;
    color: #003a70;
    font-size: 48px;
    font-weight: 600;
    margin: 87px 0 37px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 33px;
        font-weight: 400;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 24px;
        margin: 35px 0 27px;
        align-self: center;
    }    
`;

export const RedStripe = styled.div`
    position: absolute;
    top: 0;
    right: 2px;
    height: 9px;
    width: 25px;
    background-color: #ff4438;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 6px;
        width: 18px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 4px;
        width: 13px;
        right: calc(50% - 6.5px)
    }
`;

export const HandIcon = styled.img.attrs({
    src: require('../../icons/Hand.svg'),
})`
    height: 75px;
    width: 90px;
    margin: 106px 0 32px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 52px;
        width: 62px;
    }

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 45px;
        width: 54px;
        margin: 6px 0 16px;
    }
`;

export const RedTextTitle = styled.div`
    cursor: pointer;
    color: #ff4438;
    font-size: 40px;
    width: 440px;
    margin-bottom: 5px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 28px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 20px;
        text-align: center;
        width: auto;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 18px;
    }
`;

export const BlueText = styled.div`
    cursor: pointer;
    color: #003a70;
    font-size: 22px;
    width: 550px;
    margin-bottom: 51px;
    text-align: justify;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 15px;
        width: 381px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: ${MOBILE_WIDTH}px;
        text-align: center;
        width: auto;
        margin-bottom: 10px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: ${MOBILE_S_WIDTH}px;
        font-size: 14px;
    }
`;

export const MoreInfo = styled(Link)`
    display: flex;
    align-items: center;
    color: #003a70;
    font-size: 22px;
    font-weight: 600;
    width: 523px;
    text-decoration: none;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 15px;
        width: 363px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 100%;
        font-size: 13px;
        justify-content: center;
        display: ${({ hidemobile }) => hidemobile === 'true' ? 'none' : 'flex'};
    }
`;

export const MoreInfoMobile = styled(Link)`
    display: none;
    
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        display: block;
        text-decoration: none;
        color: #003a70;
        font-size: 14px;
        font-weight: 600;
        width: 199px;
        margin: 16px 0 -42px;
        text-align: center;
    }
`;

export const ArrowCircleIcon = styled.img.attrs({
    src: require('../../icons/ArrowCircle.svg'),
})`
    fill: #FF4438;
    height: 22px;
    width: 22px;
    margin-right: 10px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 15px;
        width: 15px;
        margin-right: 7px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 11px;
        width: 11px;
        margin-bottom: -2px;
    }
`;

export const TaxesRefundedTitle = styled.div`
    color: #ff4438;
    font-size: 34px;
    width: 336px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 24px;
        width: 233px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 21px;
        width: auto;
    }
`;

export const TaxesRefunded = styled.div`
    color: #003a70;
    font-size: 53px;
    font-weight: 600;
    width: 351px;
    margin-bottom: 40px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 36px;
        width: 243px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 31px;
        width: auto;
        margin-bottom: 24px;
    }
`;

export const Space = styled.span`
    margin-right: 15px;
`;

export const TaxesSubTitle = styled.div`
    color: #ff4438;
    font-size: 22px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 15px;
    }
`;

export const TaxesSubText = styled.div`
    color: #003a70;
    font-size: 40px;
    font-weight: 600;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 27px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 24px;
    }
`;

export const TaxRefundListItem = styled.div`
    height: 214px;
    width: 276px;
    background-color: #003a70;
    padding: 22px 22px 0;
    border-radius: 50px 20px 0 0;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 145px;
        width: 192px;
        border-radius: 35px 14px 0 0;
        padding: 15px 15px 0;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        border-radius: 0;
        text-align: center;
        width: 290px;
        
        :first-of-type {
            border-radius: 50px 14px 0 0;
        }
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 254px;
    }
`;

export const TaxRefundLITitle = styled.div`
    color: #eff1f5;
    font-size: 26px; 
    position: relative;
    padding-top: 8px;
    margin-bottom: 16px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 18px;
        margin-bottom: 8px;
    }
`;

export const TaxRefundLIText = styled.div`
    color: #f9f9fb;
    font-size: 22px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 15px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 16px;
    }
`;

export const TaxRefundCTA = styled(Link)`
    height: 62px;
    width: 320px;
    background-color: #ff4438;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #ffffff;
    font-size: 24px;
    align-self: center;
    margin-bottom: 88px;
    justify-content: center;
    display: flex;
    align-items: center;
    text-decoration: none;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 43px;
        width: 222px;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.5);
        font-size: 16px;
        margin-bottom: 69px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 320px;
        margin: -40px 0 49px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 284px;
    }
`;


export const TaxRefundCTAlink = styled.a`
    height: 62px;
    width: 320px;
    background-color: #ff4438;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #ffffff;
    font-size: 24px;
    align-self: center;
    margin-bottom: 88px;
    justify-content: center;
    display: flex;
    align-items: center;
    text-decoration: none;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 43px;
        width: 222px;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.5);
        font-size: 16px;
        margin-bottom: 69px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 320px;
        margin: -40px 0 49px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 284px;
    }
`;

export const InsuranceContainer = styled.div`
    display: flex;
    justify-content: center;
    background-color: #e9ecf1;
    width: 100%;
`;

export const UmbrellaIcon = styled.img.attrs({
    src: require('../../icons/Umbrella.svg'),
})`
    height: 274px;
    width: 301px;
    margin-top: 146px;
    align-self: flex-end;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 191px;
        width: 210px;
        margin-top: 120px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        display: none;
    }
`;

export const InsuranceListItem = styled.div`
    height: 254px;
    width: 276px;
    background-color: #ffffff;
    padding: 22px 22px 0;
    border-radius: 50px 20px 0 0;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 177px;
        width: 192px;
        padding: 15px 15px 0;
        border-radius: 35px 14px 0 0;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        border-radius: 0;
        text-align: center;
        width: 290px;
        
        :first-of-type {
            border-radius: 50px 14px 0 0;
        }
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 254px;
    }
`;

export const InsuranceLITitle = styled.div`
    color: #003a70;
    font-size: 26px; 
    position: relative;
    margin-bottom: 7px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 18px;
    }
`;

export const InsuranceLIText = styled.div`
    color: #003a70;
    font-size: 22px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 15px;
    }
`;

export const InsuranceCTA = styled(Link)`
    height: 62px;
    width: 320px;
    background-color: #053d72;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #ffffff;
    font-size: 24px;
    align-self: center;
    margin-bottom: 88px;
    justify-content: center;
    display: flex;
    align-items: center;
    text-decoration: none;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 43px;
        width: 222px;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.5);
        font-size: 16px;
        margin-bottom: 69px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 320px;
        margin: -40px 0 49px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 284px;
    }
`;

export const SavingIcon = styled.img.attrs({
    src: require('../../icons/Saving.svg'),
})`
    height: 52px;
    width: 46px;
    margin-bottom: 1px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 36px;
        width: 32px;
        margin-bottom: 0;
    }
`;

export const ShieldIcon = styled.img.attrs({
    src: require('../../icons/Shield.svg'),
})`
    height: 53px;
    width: 44px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 36px;
        width: 30px;
    }
`;

export const TimerIcon = styled.img.attrs({
    src: require('../../icons/Timer.svg'),
})`
    height: 48px;
    width: 48px;
    margin-bottom: 5px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 33px;
        width: 33px;
        margin-bottom: 3px;
    }
`;

export const BigCompaniesText = styled.div`
    color: #003a70;
    font-size: 22px;
    margin-bottom: 51px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 18px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 14px;
        text-align: center;
    }
`;

export const Companies = styled.div`
    display: flex;
    margin-bottom: 185px;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        flex-wrap: wrap;
        justify-content: space-evenly;
        margin-bottom: 26px;
        
        & > img {
            margin: 0 50px 69px;
        }
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        & > img {
            margin: 0 10px 25px;
            transform: scale(0.8);
        }
    }
`;

export const Company0Icon = styled.img.attrs({
    src: require('../../icons/company0.png'),
    srcSet: `${require('../../icons/company0@2x.png')} 2x, ${require('../../icons/company0@3x.png')} 3x`,
})`
    width: 214px;
    height: 39px;
`;

export const Company1Icon = styled.img.attrs({
    src: require('../../icons/company1.png'),
    srcSet: `${require('../../icons/company1@2x.png')} 2x, ${require('../../icons/company1@3x.png')} 3x`,
})`
    width: 55px;
    height: 71px;
`;

export const Company2Icon = styled.img.attrs({
    src: require('../../icons/company2.png'),
    srcSet: `${require('../../icons/company2@2x.png')} 2x, ${require('../../icons/company2@3x.png')} 3x`,
})`
    width: 103px;
    height: 59px;
`;
export const Company3Icon = styled.img.attrs({
    src: require('../../icons/company3.png'),
    srcSet: `${require('../../icons/company3@2x.png')} 2x, ${require('../../icons/company3@3x.png')} 3x`,
})`
    width: 90px;
    height: 59px;
`;
export const Company4Icon = styled.img.attrs({
    src: require('../../icons/company4.png'),
    srcSet: `${require('../../icons/company4@2x.png')} 2x, ${require('../../icons/company4@3x.png')} 3x`,
})`
    width: 175px;
    height: 59px;
`;
